module.exports = __webpack_public_path__ + "img/q7.1a82e337.png";